import { render } from "./VueProjects.vue?vue&type=template&id=4e8aefca&scoped=true"
import script from "./VueProjects.vue?vue&type=script&lang=js"
export * from "./VueProjects.vue?vue&type=script&lang=js"

import "./VueProjects.vue?vue&type=style&index=0&id=4e8aefca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8aefca"]])

export default __exports__